var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "arrange-images-form" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, "label-width": "90px" } },
            [
              _c(
                "el-form-item",
                { staticClass: "show-type", attrs: { label: "展示样式：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.changeShowCate },
                      model: {
                        value: _vm.form.imgType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "imgType", $$v)
                        },
                        expression: "form.imgType",
                      },
                    },
                    _vm._l(_vm.showTypeEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showActive
                ? [
                    _c(
                      "transition-group",
                      { attrs: { name: "fade", tag: "div" } },
                      _vm._l(_vm.form.activity, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            ref: "formItemRefs",
                            refInFor: true,
                            staticClass: "form-item",
                            class: {
                              dragstart: _vm.dragStartIndex === index,
                              dragging: _vm.dragging === index,
                            },
                            on: {
                              dragend: _vm.dragend,
                              dragover: _vm.dragover,
                              dragenter: function ($event) {
                                return _vm.handleDragenter(index)
                              },
                            },
                          },
                          [
                            _c(
                              "Card",
                              {
                                attrs: { isErrorBtn: false },
                                on: {
                                  handleDragstart: function (e) {
                                    return _vm.dragstart(e, index)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "form-item-body" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "img-box",
                                      on: {
                                        click: function ($event) {
                                          return _vm.upload(index)
                                        },
                                      },
                                    },
                                    [
                                      item.pic
                                        ? _c("img", {
                                            attrs: { src: item.pic },
                                          })
                                        : _c("i", {
                                            staticClass:
                                              "el-icon-camera cameraIconfont",
                                          }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-box" },
                                    [
                                      _c("span", { staticClass: "tip-text" }, [
                                        _vm._v("提示文字，图片位置及大小设定"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "链接：" } },
                                        [
                                          _c("JumpNative", {
                                            model: {
                                              value: item.url,
                                              callback: function ($$v) {
                                                _vm.$set(item, "url", $$v)
                                              },
                                              expression: "item.url",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("el-divider"),
                    _vm._v(" "),
                    _vm.form.activePadding
                      ? _c(
                          "div",
                          [
                            _c("span", [_vm._v("边距：")]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "左侧" } },
                              [
                                _c("el-input-number", {
                                  attrs: { min: 0 },
                                  model: {
                                    value: _vm.form.activePadding.pl,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.activePadding,
                                        "pl",
                                        $$v
                                      )
                                    },
                                    expression: "form.activePadding.pl",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "顶侧" } },
                              [
                                _c("el-input-number", {
                                  attrs: { min: 0 },
                                  model: {
                                    value: _vm.form.activePadding.pt,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.activePadding,
                                        "pt",
                                        $$v
                                      )
                                    },
                                    expression: "form.activePadding.pt",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "右侧" } },
                              [
                                _c("el-input-number", {
                                  attrs: { min: 0 },
                                  model: {
                                    value: _vm.form.activePadding.pr,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.activePadding,
                                        "pr",
                                        $$v
                                      )
                                    },
                                    expression: "form.activePadding.pr",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "底侧" } },
                              [
                                _c("el-input-number", {
                                  attrs: { min: 0 },
                                  model: {
                                    value: _vm.form.activePadding.pb,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.activePadding,
                                        "pb",
                                        $$v
                                      )
                                    },
                                    expression: "form.activePadding.pb",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("linkaddressVue", {
        ref: "linkaddressVueRef",
        on: { linkUrl: _vm.linkUrl },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }